import {
  BusinessGetResponseType,
  PromotionRewardItemGetResponseType,
} from "@sellar-io/api-v2/types";
import { ExtendedFirebaseUser } from "../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../hooks/api/v2/apiV2Request";

export const fetchPromotionalProduct = <
  TData = PromotionRewardItemGetResponseType,
>({
  user,
  business,
  promotionRewardItemId,
}: {
  user: ExtendedFirebaseUser | undefined;
  business: BusinessGetResponseType;
  promotionRewardItemId: number;
}) => {
  return apiV2Request({
    user,
    business,
    method: "get",
    path: `promotion-reward-items/${promotionRewardItemId}`,
  }).then((data) => apiV2AssertResponse<TData>(data).data);
};
